import home from "./zhCn/home";
import chat from "./zhCn/chat";
import flowWork from "./zhCn/flowWork";
import console from "./zhCn/console";
import request from "./zhCn/request";
import knowledgeBase from "./zhCn/knowledgeBase";
import database from "./zhCn/database";
import plugins from "./zhCn/plugins";
import integrations from "./zhCn/integrations";
import client from "./zhCn/client";
import custom from "./zhCn/custom";
import chatManage from "./zhCn/chatManage";
import myCenter from "./zhCn/myCenter";
import echarts from "./zhCn/echarts";
import teamSpace from "./zhCn/teamSpace";
import templateCenter from "./zhCn/templateCenter";
import workFlow from "./zhCn/workFlow";
import router18 from "./zhCn/router18";
import privige from "./zhCn/privige";
import linkAiForm from "./zhCn/linkAiForm";
export default {
  ...home,
  ...chat,
  ...flowWork,
  ...console,
  ...request,
  ...knowledgeBase,
  ...database,
  ...plugins,
  ...integrations,
  ...client,
  ...custom,
  ...chatManage,
  ...myCenter,
  ...echarts,
  ...teamSpace,
  ...templateCenter,
  ...workFlow,
  ...router18,
  ...privige,
  ...linkAiForm,
};
